import React from 'react'
import PropTypes from 'prop-types'
import { TitleH3 } from '../../../styles/atoms/StyledComponents'

const TextTitle = ({ text, stylesElement }) => {
  return (
    <>
      {stylesElement
        ?       
          <TitleH3
          {...stylesElement}
          data-testid="text-title"
          >
            {text}
          </TitleH3 >
        : 
        <TitleH3
          data-testid="text-title"
        >
            {text}
          </TitleH3 >
          
      }

    </>
    
  )
}

TextTitle.propTypes = {
  text: PropTypes.string.isRequired,
  stylesElement: PropTypes.object,
}

export default TextTitle
